// extracted by extract-css-chunks-webpack-plugin
module.exports = {"locale-switch":"locale-switch__locale-switch--3A05p","localeSwitch":"locale-switch__locale-switch--3A05p"};